import React from "react"
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogFooter,
    DialogTitle,
    DialogDescription,
    DialogTrigger,
} from "../../../components/ui/dialog"
import { Button } from "../../../components/ui/button"

const ConfirmDialog = ({
    isShow,
    setIsDialogOpen,
    title = "Are you sure?",
    description = "This action is irreversible.",
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
}) => {
    return (
        <Dialog open={isShow} onOpenChange={() => setIsDialogOpen({
            isShow: false,
            onConfirm: () => { },
        })}>
            <DialogContent className="xs:max-w-sm rounded-2xl">
                <p className="text-md">
                    {title}
                </p>
                <DialogFooter className="flex justify-end gap-2 mt-4">
                    <DialogTrigger asChild>
                        <Button variant="outline">{cancelText}</Button>
                    </DialogTrigger>
                    <DialogTrigger asChild>
                        <Button variant="destructive" onClick={onConfirm}>
                            {confirmText}
                        </Button>
                    </DialogTrigger>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default ConfirmDialog
